import React from 'react';
import { useCurrency } from '@/hooks/useCurrency';

const CURRENCIES = [
  { code: 'EUR', symbol: '€', name: 'Euro' },
  { code: 'USD', symbol: '$', name: 'US Dollar' },
  { code: 'GBP', symbol: '£', name: 'British Pound' },
  { code: 'JPY', symbol: '¥', name: 'Japanese Yen' },
  { code: 'CNY', symbol: '¥', name: 'Chinese Yuan' },
  { code: 'INR', symbol: '₹', name: 'Indian Rupee' },
  { code: 'CHF', symbol: 'CHF', name: 'Swiss Franc' },
  { code: 'CAD', symbol: 'C$', name: 'Canadian Dollar' },
  { code: 'AUD', symbol: 'A$', name: 'Australian Dollar' },
  { code: 'SGD', symbol: 'S$', name: 'Singapore Dollar' },
  { code: 'HKD', symbol: 'HK$', name: 'Hong Kong Dollar' },
  { code: 'KRW', symbol: '₩', name: 'South Korean Won' },
  { code: 'AED', symbol: 'AED', name: 'UAE Dirham' },
];

export function CurrencySelector() {
  const { currency, setCurrency } = useCurrency();
  const [open, setOpen] = React.useState(false);
  const containerRef = React.useRef<HTMLDivElement | null>(null);
  const currentCurrency = CURRENCIES.find(c => c.code === currency);

  React.useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (!containerRef.current) return;
      if (!containerRef.current.contains(event.target as Node)) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);
    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, []);

  return (
    <div ref={containerRef} className="relative">
        <button
          type="button"
          className="flex h-10 items-center gap-1 rounded-xl border border-blue-200/80 bg-blue-50/85 px-3 text-blue-700 hover:bg-blue-100 dark:border-blue-400/25 dark:bg-blue-500/10 dark:text-blue-200 dark:hover:bg-blue-500/20"
          aria-label="Currency selector"
          aria-expanded={open}
          onClick={() => setOpen((prev) => !prev)}
        >
          <span className="text-lg">{currentCurrency?.symbol}</span>
          <span className="text-sm font-medium">{currentCurrency?.code}</span>
        </button>

      {open && (
        <div className="absolute right-0 mt-2 min-w-[12rem] overflow-hidden rounded-2xl border border-gray-200 bg-white/95 p-1.5 text-popover-foreground shadow-[0_20px_48px_-24px_rgba(15,23,42,0.45)] backdrop-blur-xl dark:border-gray-700 dark:bg-gray-800/95 z-[120]">
          {CURRENCIES.map((curr) => (
            <button
              type="button"
              key={curr.code}
              onClick={() => {
                setCurrency(curr.code);
                setOpen(false);
              }}
              className="flex w-full items-center gap-2 rounded-xl px-2.5 py-2 text-left text-sm transition-colors hover:bg-blue-50 dark:hover:bg-blue-900/20"
            >
              <span className="text-lg">{curr.symbol}</span>
              <span>{curr.name}</span>
              <span className="ml-2 text-sm text-gray-500">({curr.code})</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
